import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

/**
 * The legacy Ratings bar chart (ADR-034 D6): how many rated manuals round to 5 … 1 stars, each bar a filter toggle for
 * that band. A `<figure>` whose label carries the numbers; the bars are buttons with `aria-pressed`.
 */
export function RatingBars({ distribution, selected, onSelect }: { distribution: readonly number[]; selected: 0 | 1 | 2 | 3 | 4 | 5; onSelect: (r: 1 | 2 | 3 | 4 | 5) => void }) {
  const { t } = useTranslation();
  const max = Math.max(1, ...distribution);
  const summary = distribution.map((n, i) => t("dashboard.countAtStars", { count: n, stars: 5 - i })).join(", ");
  return (
    <figure aria-label={t("dashboard.ratedManualsByAverageSummary", { summary: summary })} className="m-0 flex flex-col gap-1">
      {distribution.map((n, i) => {
        const stars = (5 - i) as 1 | 2 | 3 | 4 | 5;
        const on = selected === stars;
        return (
          <button
            key={stars}
            type="button"
            aria-pressed={on}
            aria-label={t("dashboard.starsWithManuals", { stars, count: n })}
            onClick={() => onSelect(stars)}
            className={cn("hover:bg-muted focus-visible:ring-ring/50 flex cursor-pointer items-center gap-2 rounded border-0 bg-transparent px-1 py-0.5 text-xs outline-none focus-visible:ring-2", on && "bg-muted")}
          >
            <span className="w-14 shrink-0 text-left">{stars} ★</span>
            <span className="bg-muted h-2.5 min-w-0 flex-1 overflow-hidden rounded-sm">
              <span aria-hidden="true" className={cn("block h-full rounded-sm", on ? "bg-attention" : "bg-primary")} style={{ width: `${String((n / max) * 100)}%` }} />
            </span>
            <span className="w-8 shrink-0 text-right tabular-nums">{n}</span>
          </button>
        );
      })}
    </figure>
  );
}
